import React from 'react';
import { Wallet, Users, PhoneCall, Target } from 'lucide-react';
import { advantages, servicesTable } from '../mock';

const iconMap = { wallet: Wallet, users: Users, 'phone-call': PhoneCall, target: Target };

export default function Advantages() {
  return (
    <section className="bg-gradient-to-b from-white to-[#f7fbfd] py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="text-xs font-bold uppercase tracking-widest text-orange-600">Why Choose Us</div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#0b3d5b] mt-2">Register Point Advantage</h2>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">Everything you need to make compliance simple, fast and reliable.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {advantages.map((a, i) => {
            const Icon = iconMap[a.icon];
            return (
              <div key={i} className="group bg-white rounded-2xl border border-slate-100 p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-orange-100 to-orange-200 flex items-center justify-center group-hover:from-orange-500 group-hover:to-orange-600 transition-colors">
                  <Icon className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-4 font-bold text-[#0b3d5b] text-lg">{a.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{a.description}</p>
              </div>
            );
          })}
        </div>

        {/* Services table */}
        <div className="mt-16">
          <h3 className="text-xl md:text-2xl font-bold text-[#0b3d5b] text-center">All online CA services provided by Register Point</h3>
          <div className="mt-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <table className="w-full text-sm">
              <tbody>
                {servicesTable.map((row, r) => (
                  <tr key={r} className={r % 2 ? 'bg-slate-50/60' : 'bg-white'}>
                    {row.map((cell, c) => (
                      <td key={c} className="px-4 py-3.5 border-b border-slate-100 text-slate-700 hover:text-orange-600 hover:bg-orange-50/50 transition-colors cursor-pointer">
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
